var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3815",
    "data-name": "Group 3815",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:var(--primary-color)}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M10 0h43a10 10 0 0 1 10 10v43a10 10 0 0 1-10 10H10A10 10 0 0 1 0 53V10A10 10 0 0 1 10 0z",
    style: {
      fill: "var(--secondary-color)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    transform: "translate(14.4 13.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    className: "cls-2",
    d: "M695.881 258.526h12.466a.8.8 0 0 0 0-1.609h-12.466a.8.8 0 0 0 0 1.609z",
    transform: "translate(-688.514 -240.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    className: "cls-2",
    d: "M703.345 281.541h-7.463a.8.8 0 0 0 0 1.609h7.463a.8.8 0 1 0 0-1.609z",
    transform: "translate(-688.514 -259.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    className: "cls-2",
    d: "M692.956 197.964v-13.9a4.022 4.022 0 0 0-4.021-4.022h-3.3v-1.536a.8.8 0 0 0-1.609 0v1.536h-10.935v-1.536a.8.8 0 1 0-1.608 0v1.536h-3.3a4.023 4.023 0 0 0-4.022 4.022v21.788a4.023 4.023 0 0 0 4.022 4.021h14.887a8.848 8.848 0 1 0 9.884-11.912zm-24.763-16.31h3.3v1.536a.8.8 0 1 0 1.608 0v-1.536h10.938v1.536a.8.8 0 1 0 1.609 0v-1.536h3.3a2.42 2.42 0 0 1 2.413 2.413v1.946H665.78v-1.946a2.414 2.414 0 0 1 2.413-2.414zm0 26.614a2.42 2.42 0 0 1-2.413-2.413v-18.242h25.568v10.2h-.024a8.861 8.861 0 0 0-8.7 10.456zm23.131 5.63a7.239 7.239 0 1 1 7.239-7.239 7.239 7.239 0 0 1-7.239 7.241z",
    transform: "translate(-664.163 -177.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    className: "cls-2",
    d: "m777.669 299.651-4.777 4.56-2.469-2.477a.8.8 0 0 0-1.134 1.134l3.032 3.032a.791.791 0 0 0 .571.233.777.777 0 0 0 .555-.225l5.341-5.107a.8.8 0 0 0 .024-1.134.818.818 0 0 0-1.143-.016z",
    transform: "translate(-746.785 -273.584)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGroup);
export default __webpack_public_path__ + "static/media/calendarGroup.2417e0ad.svg";
export { ForwardRef as ReactComponent };